import { CertificateFault } from './types';

type UseCertificateFaultHandlerMapConfig = {
   onAuthenticationRequired: VoidFunction;
   onCertificateNoLongerValid: VoidFunction;
   onNoValidCertificateFound: VoidFunction;
   onInvalidPrivateKeyFault: VoidFunction;
};

type UseCertificateFaultHandlerMapOptions = {
   onAuthenticationRequired?: VoidFunction;
   onCertificateNoLongerValid?: VoidFunction;
};

type CertificateFaultHandlerMap = {
   [F in CertificateFault as F['class']]: (fault: F) => void;
};

export const createUseCertificateFaultHandlerMap = (config: UseCertificateFaultHandlerMapConfig) => (
   options?: UseCertificateFaultHandlerMapOptions
): CertificateFaultHandlerMap => {
   return {
      'egabinet-truststore:PrivateKeyNotDecodedFault': () => {
         if (options?.onAuthenticationRequired) {
            return options.onAuthenticationRequired?.();
         }

         return config.onAuthenticationRequired();
      },
      'egabinet-personal-certificate-frontend-api:CertificateNoLongerValidFault': () => {
         if (options?.onCertificateNoLongerValid) {
            return options.onCertificateNoLongerValid?.();
         }

         return config.onCertificateNoLongerValid();
      },
      'egabinet-truststore:NoValidCertificateFoundFault': config.onNoValidCertificateFound,
      'egabinet-truststore:InvalidPrivateKeyFault': config.onInvalidPrivateKeyFault,
   };
};
